import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Icon, Button } from '@fiverr-private/fit';
import { r_bell } from '@fiverr-private/fit/icons';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { OPENED_SETTING_MODAL } from '../../../Utils/mixpanel/mixpanelEvents';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import NameModal from '../NameModal';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as Translations from '../../providers/i18n';

import './style.scss';

const orange = '#FC832B';

const CollaboratorNoUsernameAlert = ({ shouldDisplay, collaboratorId, i18n }) => {

    const handleClick = (open) => {
        open();

        sendMixPanelEvent({
            eventName: OPENED_SETTING_MODAL,
            eventData: {
                'Start Collaborate Source Component': 'Banner'
            }
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'external_collaborator_click_start_collaborating',
            collaboration: {
                collaborator: {
                    id_str: collaboratorId
                }
            }
        });
    };

    if (!shouldDisplay) {
        return null;
    }

    return (
        <div className="no-name-wrapper">
            <div className="no-name-main">
                <div className="no-name-message">
                    <div className="no-name-icon">
                        <Icon color={orange}>{r_bell}</Icon>
                    </div>
                    <div className="no-name-body font-accent">
                        <h3>{i18n.t('attachments_preview.CollaboratorNoUsernameAlert.title')}</h3>
                        <p>{i18n.t('attachments_preview.CollaboratorNoUsernameAlert.text')}</p>
                    </div>
                </div>
                <NameModal trigger={(open) => (
                    <Button fill="ghost"
                        color="grey"
                        onClick={() => handleClick(open)}>
                        {i18n.t('attachments_preview.CollaboratorNoUsernameAlert.button')}
                    </Button>)}/>
            </div>
        </div>
    );
};

CollaboratorNoUsernameAlert.propTypes = {
    shouldDisplay: PropTypes.bool,
    collaboratorId: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

CollaboratorNoUsernameAlert.defaultProps = {
    shouldDisplay: false,
    collaboratorId: ''
};

const mapStateToProps = (state, { collaboratorId }) => ({
    shouldDisplay: CollaboratorsSelectors.isPresentAndIsWithoutUsernameByCollaboratorId(state, collaboratorId),
    collaboratorId
});

export default compose(
    Translations.connect,
    connect(mapStateToProps))(CollaboratorNoUsernameAlert);
